<template>
  <canvas id="radarChart" width="200" height="200"></canvas>
</template>

<script>
// import Chart from 'chart.js'
import { Chart } from 'chart.js'
export default {
  name: 'radarChart',
  props: {
  },
  computed: {
  },
  mounted () {
    const ctx = document.getElementById('radarChart')
    new Chart(ctx, {
      type: 'radar',
      data: {
        labels: ['準確度', '韻律', '完整度', '流暢度'],
        datasets: [{
          label: '分數',
          data: [80, 60, 80, 70],
          backgroundColor: 'rgba(254, 195, 255, 0.3)',
          borderColor: 'rgba(253, 156, 255, 1)',
          borderWidth: 2
        }]
      },
      options: {
        scale: {
          ticks: {
            beginAtZero: true,
            max: 100
          }
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
